const isProduction = process.env.NEXT_PUBLIC_NODE_ENV?.includes("production")
    ? true
    : false;

export default isProduction;
